import { AxiosInstance } from "axios";
import { ISessionDelegate } from "../interfaces/ISessionDelegate";

export class SessionDelegateService {
    private apiClient: AxiosInstance;
    private endpoint: string;
    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
        this.endpoint = '/admin/session-delegate';
    }

    async getAll(sessionId: string): Promise<ISessionDelegate[]> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${sessionId}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async get(sessionId: string, id: string): Promise<ISessionDelegate> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${sessionId}/${id}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
}